
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","viewBox":"0 1 27 27","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M24.907 1.156H1.958C.91 1.156.06 2.006.06 3.055v13.778L0 27.233l5.985-5.943h18.922a1.9 1.9 0 001.9-1.898V3.055a1.9 1.9 0 00-1.9-1.9","fill":"#FFE86C"}}),_c('path',{attrs:{"fill":"#005149","d":"M14.25 14.345l.3-10.422h-2.294l.299 10.422zm-.847 1.229c-.794 0-1.37.602-1.37 1.434 0 .83.576 1.433 1.37 1.433.794 0 1.37-.604 1.37-1.433 0-.844-.563-1.434-1.37-1.434"}})])])
          )
        }
      }
    